import { array, boolean, nativeEnum, number, object, string, z } from 'zod';

import {
  AwardPointsSchema,
  CustomDataSchema,
  OfferFulfillmentPrioritySchema,
  OfferNameAndDescriptionSchema,
  ProductGroupsSchema,
  ScanDataConfigurationSchema,
  VoucheredOfferSchema,
} from '@occc/validation';
import {
  awardRestrictionsSchema,
  FulfillmentChannelConstraintSchema,
  fulfillmentWindowSchema,
  minimumPurchaseConstraintsSchema,
  PaymentMethodConstraintSchema,
  requiresActivationConstraintWithLimitsSchema,
} from '@occc/feat-constraints/schemas';
import { Earning_Mechanism_Product_Counting_Attribute } from '@occc/graphql';
import { AwardType } from '@occc-app/offerHelpers/types';

import { ChallengeAwardCountSchema } from './award-count.schema';

export const BaseChallengeSchema = OfferNameAndDescriptionSchema.merge(
  OfferFulfillmentPrioritySchema,
).extend({
  earningMechanism: object({ id: string().optional() }),
  awardCount: ChallengeAwardCountSchema,
  activation: requiresActivationConstraintWithLimitsSchema,
  fulfillmentWindow: fulfillmentWindowSchema,
  minimumPurchaseConstraints: minimumPurchaseConstraintsSchema,
  paymentMethodConstraint: PaymentMethodConstraintSchema,
  fulfillmentChannelConstraint: FulfillmentChannelConstraintSchema,
  awardRestrictions: awardRestrictionsSchema,
  customData: CustomDataSchema.optional(),
  scanDataConfiguration: ScanDataConfigurationSchema.optional(),
  campaign: object({
    uuid: string().min(1),
    name: string(),
  }).optional(),
  award: object({
    awardType: nativeEnum(AwardType).optional(),
    awardPoints: AwardPointsSchema.partial().optional(),
    awardVouchers: object({
      voucheredOffer: VoucheredOfferSchema.partial().passthrough().optional(),
      isEnabled: boolean().optional(),
      voucherCount: number().optional(),
      voucherExpirationDays: number().optional(),
    })
      .partial()
      .optional(),
  })
    .partial()
    .optional(),
  visitChallenge: object({
    id: string().optional(),
    visitThreshold: number().optional(),
  }).optional(),
  productChallenge: object({
    products: array(
      object({
        purchaseThreshold: number().optional(),
        eligibleProductGroups: ProductGroupsSchema.optional(),
        countProductsBy: nativeEnum(Earning_Mechanism_Product_Counting_Attribute).optional(),
      }),
    ).optional(),
    earningMechanism: z.enum(['varietyPurchase', 'varietyPurchaseOverTime']).optional(),
    stayVisibleWhileInProgress: object({ isEnabled: boolean() }).optional(),
  }).optional(),
});
